import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Home from "@/pages/Home";
import Schedule from "@/pages/Schedule";
import Mustangs from "@/pages/Mustangs";
import MustangProfile from "@/pages/MustangProfile";
import Scores from "@/pages/Scores";
import More from "@/pages/More";
import Shop from "@/pages/Shop";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Judges from "@/pages/Judges";
import About from "@/pages/About";
import FanFavorite from "@/pages/FanFavorite";
import Vendors from "@/pages/Vendors";
import Sponsors from "@/pages/Sponsors";
import EventMap from "@/pages/EventMap";
import Announcements from "@/pages/Announcements";
import Faq from "@/pages/Faq";
import Game from "@/pages/Game";
import GameSetup from "@/pages/GameSetup";
import GameReset from "@/pages/GameReset";
import GameHorsePublic from "@/pages/GameHorsePublic";
import GameBarnPublic from "@/pages/GameBarnPublic";
import { GameAuthProvider } from "@/context/GameAuthContext";
import { OfflineIndicator } from "@/components/OfflineIndicator";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <GameAuthProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <OfflineIndicator />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/mustangs" element={<Mustangs />} />
              <Route path="/mustangs/:id" element={<MustangProfile />} />
              <Route path="/scores" element={<Scores />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/more" element={<More />} />
              <Route path="/judges" element={<Judges />} />
              <Route path="/about" element={<About />} />
              <Route path="/fan-favorite" element={<FanFavorite />} />
              <Route path="/auction" element={<Navigate to="/mustangs?auction=1" replace />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/map" element={<EventMap />} />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/game" element={<Game />} />
              <Route path="/game/horse/:pn/:aid" element={<GameHorsePublic />} />
              <Route path="/game/barn/:barnId" element={<GameBarnPublic />} />
              <Route path="/game/setup" element={<GameSetup />} />
              <Route path="/game/reset" element={<GameReset />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </FavoritesProvider>
        </GameAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
